import React, { useEffect, useState } from "react";
import { Box, Grid, Rating, Typography, useTheme, useMediaQuery } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { SidebarContainer } from "../../../component/organism";
import HeadingComponent from "../../../component/atom/Headings/Heading";
import { QuizAttemptCard, QuizMainCard } from "../../../component/molecule";
import { QuizFirstCard } from "../../../component/molecule";
import { CircularWithValueLabel, TextIconButtonComponent } from "../../../component/atom";
import { connect } from "react-redux";
import { Actions } from "../../../core/modules/Actions";
import { IconButtonComponent } from "../../../component/atom";
import moment from 'moment';
import _ from "lodash";
import { USER_ROLE } from "../../../core/Constant";
import { BarChart, LineChart } from "@mui/x-charts";
import { faChartLine } from "@fortawesome/free-solid-svg-icons";


// const ca1 = [40, 30, 20, 27, 18, 90, 49];
// const ca2 = [24, 39, 98, 39, 0, 38, 43];
// const ca3 = [45, 92, 90, 31, 20, 37, 90];
// const xLabels = [
//   '1',
//   '2',
//   '3',
//   '4',
//   '5',
//   '6',
//   '7',
// ];

const valueFormatter = (value) => {
  return `${value} %`
};

const chartSetting = {
  yAxis: [
    {
      label: 'Marks (%)',
    },
  ],
  series: [{ dataKey: 'marks', label: 'Marks', color: '#9834F076', valueFormatter }],
  // height: 300,
  // sx: {
  //   [`& .${axisClasses.directionY} .${axisClasses.label}`]: {
  //     transform: 'translateX(-10px)',
  //   },
  // },
};

const QuizAttemptScreen = ({ stdgetquizAttempts, attemptsData, }) => {
  const navigate = useNavigate();
  const [newquiz, setQuiz] = useState('');
  const [attempts, setAttempts] = useState([]);
  const location = useLocation();
  const [userType, setUserType] = useState(1);
  const [newList, setNewList] = useState([]);
  const [series, setSeries] = useState([]);
  const [xLabels, setXLabels] = useState([]);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); 
  const mobileSize = window.innerWidth;


  useEffect(() => {
    getUserType()
  }, []);

  const getUserType = async () => {
    const type = localStorage.getItem('userType');
    setUserType(type)
  };


  useEffect(() => {
    const qId = location.state?.quiz;
    setQuiz(qId)
    stdgetquizAttempts(qId?.id);
  }, [location]);

  useEffect(() => {
    setAttempts(attemptsData)
    const list = _.orderBy(attemptsData, ['attempts'], ['asc']);
    const result = _.map(list, item => {
      return { attempt: item?.attempts, marks: parseFloat(item?.marks) }
    });
    setNewList(result);
    const dataAttempt = _.filter(list, i => i?.category_results?.length > 0);

    const dataSet = _(dataAttempt).map(i => i?.category_results).flatten().groupBy('category_name').map((items, label) => {
      return { label, data: items.map(item => item.marks) }
    }).value();


    setSeries(dataSet);
    setXLabels(_.map(dataAttempt, i => i?.attempts))

    //  [{data:[],label}]
  }, [attemptsData]);

  const formattedLabels = xLabels.map(label =>
    label.length > 10 ? label.slice(0, 10) + '\n' + label.slice(10) : label
  );

  const onViewAttemptForm = (id, user, quizid, name, attempt) => {
    navigate('/quiz-attempt-form', { state: { quiz_status_id: id, user_id: user, quiz_id: quizid, quiz_name: name, attempt } });
  }

  return (
    <>
      <Grid className="main-screen-container" container flexDirection={"column"} rowSpacing={1} mt={2}>
        <Grid item>
          <Grid container justifyContent={"space-between"}>
            <Grid item>
              <IconButtonComponent
                onclick={() => navigate(userType == USER_ROLE.admin ? -1 : '/quiz')}
                btnType="backbtn"
                btnText="Back"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container alignItems={"center"} justifyContent={"space-between"}>
            <Grid item>
              <Box>
                <p className="quiz-attempt-subtext">{newquiz?.name}</p>
              </Box>
            </Grid>
            <Grid item>
              <TextIconButtonComponent
                buttonStyleClass="btn btn-primary"
                btnText={"Show Result In Graph"}
                icon={faChartLine}
                onclick={() => navigate('/quiz-attempt-result', { state: { quiz: location?.state?.quiz } })}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item>
          <Grid container>
            <Grid item sx={{ display: 'flex', justifyContent: 'center' }} xs={12}>
              <HeadingComponent text={`Quiz Progress`} fontfamily={"Montserrat"} fontweigth={560} size={25} />
            </Grid>
            <Grid item xs={12}>
              <Grid
                container
                spacing={2}
                justifyContent="center"
                alignItems="flex-start"
                sx={{
                  flexDirection: {
                    xs: 'column', // Stack vertically on small screens
                    md: 'row',    // Side-by-side or same layout on large
                  },
                  flexWrap: 'wrap',
                }}
              >
                <Grid item xs={12} md={12}>
                  <Box>
                    {newList?.length > 0 && (
                      <BarChart
                        xAxis={[{ scaleType: 'band', dataKey: 'attempt' }]}
                        dataset={newList}
                        {...chartSetting}
                        width={600}
                        height={400}
                        tooltip={{ trigger: 'axis' }}
                        viewBox={"0 100 600 400"}
                      />
                    )}
                  </Box>
                </Grid>

                <Grid item xs={12} md={12}>
                  <Box sx={{ overflowX: 'auto' }}>
                    <Box sx={{ minWidth: { xs: 700, sm: 920 } }}>
                      {xLabels?.length > 0 && (
                        <LineChart
                          width= {isMobile ? '600' : '920'}
                          height={400}
                          series={series}
                          xAxis={[
                            {
                              scaleType: 'point',
                              dataKey: 'attempts',
                              data: xLabels,
                              tickPlacement: 'middle',
                              tickLabelPlacement: 'middle',
                              label: 'Attempts',
                              tickLabelFormatter: (label) => {
                                // Insert line break every 8 characters
                                if (typeof label === 'string' && label.length > 8) {
                                  return label.match(/.{1,8}/g).join('\n');
                                }
                                return label;
                              },
                              tickLabelStyle: {
                                fontSize: 12,
                                whiteSpace: 'pre-line',
                                wordBreak: 'break-word',
                                maxWidth: 60,
                                textAlign: 'center',
                              },
                            },
                          ]}
                          yAxis={[{ label: 'Marks' }]}
                          legend={{
                            direction: isMobile ? 'row' : 'column',
                            position: isMobile
                              ? { vertical: 'bottom', horizontal: 'left' }
                              : { vertical: 'middle', horizontal: 'right' },
                            padding: 5,
                            labelStyle: {
                              fontSize: 12,
                              maxWidth: 120,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            },
                          }}
                          margin={
                            isMobile
                              ? { top: 10, bottom: 165, left: 10, right: 40 }
                              : { top: 40, bottom: 60, left: 40, right: 450 }
                          }
                          sx={{
                            '& .MuiChartsSurface-root': {
                              overflow: 'visible',
                            },
                          }}
                        />
                      )}
                    </Box>
                  </Box>
                </Grid>

              </Grid>
            </Grid>



          </Grid>
        </Grid>

        {attemptsData.length === 0 ? (
          <p>No data found <br/>
          Attempt again</p>
        ) : (
          <Grid item xs={12}>
            <Box width="100%" padding={0} alignItems="center" justifyContent="center" p={1}>
              {attempts.map((item, index) => (
                <Grid
                  item
                  xs={12}         // Full width on mobile

                  key={`attempt${index}`}
                >
                  <QuizAttemptCard
                    itemData={item}
                    index={attempts?.length - index}
                    key={`attempt${index}`}
                    onButtonClick={() =>
                      onViewAttemptForm(item.id, item.user_id, item.quiz_id, newquiz?.name, item?.attempts)
                    }
                    attempt={item.attempts}
                    time={moment(new Date(_.get(item, 'finished_at', new Date()))).format('hh:mm a')}
                    date={moment(new Date(_.get(item, 'finished_at', new Date()))).format('Do MMM YYYY')}
                    marks={item.marks}
                  />
                </Grid>
              ))}
            </Box>
          </Grid>
        )}
      </Grid>
    </>
  );

}

export default connect(state => ({
  attemptsData: state.quizes.get('attemptsData'),
  startData: state.quizes.get('startData')
}),
  {
    stdgetquizAttempts: Actions.quizes.stdgetquizAttempts,
  }
)(QuizAttemptScreen); 
